// extracted by mini-css-extract-plugin
export var box = "Team-module--box--8f025";
export var box_md = "Team-module--box_md--15bad";
export var box_xmd = "Team-module--box_xmd--bc547";
export var box_flex = "Team-module--box_flex--0568a";
export var box_lg = "Team-module--box_lg--b6573";
export var box_sm = "Team-module--box_sm--4cd60";
export var box_outer = "Team-module--box_outer--45fe9";
export var box_whiteBg = "Team-module--box_white-bg--17db2";
export var box_noMarginBottom = "Team-module--box_no-margin-bottom--04b75";
export var box_noPadding = "Team-module--box_no-padding--639e6";
export var box_outerGray = "Team-module--box_outer-gray--40068";
export var box_dark = "Team-module--box_dark--72331";
export var box_zIndex = "Team-module--box_z-index--31c1b";
export var box_zIndex6 = "Team-module--box_z-index-6--9be4d";
export var box_eventsWithLine = "Team-module--box_events-with-line--2185d";
export var box_featuresAo = "Team-module--box_features-ao--4924a";
export var box_verticalPaddings = "Team-module--box_vertical-paddings--ab0ee";
export var clearP = "Team-module--clearP--63614";
export var clearP_vc = "Team-module--clearP_vc--5e279";
export var container = "Team-module--container--60def";
export var layout = "Team-module--layout--e9b29";
export var sliderWrapper = "Team-module--sliderWrapper--61a66";
export var slide = "Team-module--slide--94d54";
export var fadeInAnimation = "Team-module--fadeInAnimation--1c558";
export var placeHolderShimmer = "Team-module--placeHolderShimmer--76cf5";